/**
 * Created by rathompson on 10/11/22
 * File: DomUtils
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

export const isElement = (el: any) => !!el && el instanceof Element

export const isNode = (node: any) => !!node && node instanceof Node
